import { Content, ContentType } from "models/content/Content"
import { cacheRequest, makeRequest } from "./networkUtils"

export const getContents = (type?: ContentType, published?: boolean): Promise<Content[]> => {
    return makeRequest(`contents?type=${type || ""}&published=${published || false}`)
}

export const getContent = (id: string): Promise<Content> => {
    return makeRequest(`contents/${id}`)
}

export const createContentDO = (content: Content): Promise<Content> => {
    return makeRequest("contents", { method: "POST", body: content })
}

export const saveContentDO = (content: Content) => {
    return cacheRequest(`contents/${content.id}`, { method: "PUT", body: content })
}

export const deleteContentDO = (content: Content): Promise<void> => {
    return makeRequest(`contents/${content.id}`, { method: "DELETE" })
}

export const publishContents = (): Promise<void> => {
    return makeRequest("contents/publish", { method: "POST" })
}

export const getContentStats = (): Promise<void> => {
    return makeRequest("contents/stats")
}